<div class="modal-header">
  <h3 class="modal-title">Adicionar Comentário à Ocorrência de Máquina</h3>
</div>
<div class="modal-body">
  <ng-include src="'views/ocorrencias_maquinas/modal/cabecalho.html'"></ng-include>
  <div class="row">
    <div class="col-xs-12">
      <textarea class="form-control" placeholder="Comentário" ng-model="ocorrencia.comentario" autofocus></textarea>
    </div>
  </div>
</div>
<div class="modal-footer">
  <div class="btn btn-default btn-sm btn-action" ng-click="closeModalOcorrencia()">Cancelar</div>
  <div class="btn btn-success btn-sm btn-action" ng-click="saveComment()">Salvar</div>
</div>